<template>
    <div class="top-breadcrumbs">
        <p @click="handleGoIndex">运营指南</p>
        <div class="breadcrumbs-icon"></div>
        <span>商家活动</span>
    </div>
    <div class="cont top">
        <div class="title">参加活动能获得什么？</div>
        <ul class="circle">
            <li>
                <strong style="padding: 0 0 10px 0;">稀有站外资源掉落</strong>
                <p>小红书官方账号宣传、微信公众号推文等，这些资源是商家活动专属奖励哦；</p>
            </li>
            <li>
                <strong>超大量金币掉落</strong>
                <p>商家活动是发放金币最多的项目，是商家朋友绝对不能错过的。通过活动页面，可以领取、获得不等的丰厚金币奖励，参与任务越多，获得金币就丰厚。</p>
            </li>
        </ul>
        <el-image 
            style="width: 382px;margin: 15px 0 0 0;"
            class="pc-image"
            :src="activity1"
            :preview-src-list="imageList"
            :initial-index="0"
            :preview-teleported="true"
            fit="contain"
            loading="lazy"
        />
    </div>
    <div class="cont">
        <div class="title">金币怎么使用？</div>
        <p>当您的项目上线后，金币可用于兑换下列站内核心资源位，增加项目曝光，提高众筹金额。</p>
        <el-image 
            class="enlarged pc-image"
            :src="activity2"
            :preview-src-list="imageList"
            :initial-index="1"
            :preview-teleported="true"
            fit="contain"
            loading="lazy"
        />
    </div>
    <div class="cont">
        <div class="title">商家活动怎么参与？</div>
        <p style="line-height: 1.5;">在活动期间，发布创意、发布项目等视为参与活动，均可获得对应的金币奖励；</p>
        <p style="line-height: 1.5;">具体活动内容，以实际活动玩法为准。</p>
    </div>
    <div class="cont">
        <div class="title">哪里能看到商家活动？</div>
        <p>商家活动主要入口具体如下：</p>
        <p style="font-weight: 600;padding: 15px 0 0 0;">pc端入口：pc首页顶部通栏</p>
        <el-image 
            class="enlarged pc-image"
            :src="activity3"
            :preview-src-list="imageList"
            :initial-index="2"
            :preview-teleported="true"
            fit="contain"
            loading="lazy"
        />
        <p style="font-weight: 600;padding: 60px 0 20px 0;">app端入口：商家中心banner</p>
        <el-image 
            class="enlarged app-image"
            :src="activity4"
            :preview-src-list="imageList"
            :initial-index="3"
            :preview-teleported="true"
            fit="contain"
            loading="lazy"
        />
        <p style="font-weight: 600;padding: 60px 0 20px 0;">添加商家活动顾问企微咨询 </p>
        <p style="padding: 0 0 20px 0;"><a href="javascript:void(0);" @click="handleGoWechat">点击添加</a></p>
        <el-image 
            class="enlarged app-image"
            style="margin: 20px 0 20px 20px;"
            :src="activity5"
            :preview-src-list="imageList"
            :initial-index="4"
            :preview-teleported="true"
            fit="contain"
            loading="lazy"
        />
        <p style="font-weight: 600;padding: 60px 0 0 0;">也可以点击「前往任务中心」查看 </p>
        <el-button style="margin: 40px 0 0 0;" type="primary" @click="handleGoTask">前往任务中心</el-button>
        
        <!-- 图片预览组件 -->
        <el-image-viewer
            v-if="showViewer"
            :url-list="imageList"
            :initial-index="4"
            @close="showViewer = false"
        />
    </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'

// 统一管理CDN地址
const CDN_BASE = 'https://p6.moimg.net/mdwxapp/guide/'

const activity1 = `${CDN_BASE}activity_1.png`
const activity2 = `${CDN_BASE}activity_2.png`
const activity3 = `${CDN_BASE}activity_3.png`
const activity4 = `${CDN_BASE}activity_4.png`
const activity5 = `${CDN_BASE}activity_5.png`

// 图片列表，用于预览
const imageList = [activity1, activity2, activity3, activity4, activity5]

// 控制图片预览器显示状态
const showViewer = ref(false)

const router = useRouter()
const handleGoTask = () => {
    router.push((`/operate_manage/task`))
}
const handleGoWechat = () => {
    // 显示图片预览器，从task2开始（索引为1）
    showViewer.value = true
}
const handleGoIndex = () => {
    if(sessionStorage.getItem('guide_pro_id')){
        router.push(`/project_manage/index/${sessionStorage.getItem('guide_pro_id')}`)
    } else {
        router.push((`/project_manage/index`))
    }
}

</script>

<style lang="scss" scoped>
.top-breadcrumbs{
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    padding: 0 0 40px 0;
    p{
        color: #7F7F7F;
        cursor: pointer;
    }
    .breadcrumbs-icon{
        width: 14px;
        height: 14px;
        margin: 0 10px;
        background: url('~@/assets/images/icon_right.png') no-repeat center center;
        background-size: contain;
    }
    span{
        color: #1A1A1A;
    }
}
.cont{
    margin: 60px 0 0 0;
    color: #1A1A1A;
    &.top{
        margin: 0;
    }
    .title{
        font-size: 24px;
        font-weight: 600;
        margin: 0 0 25px 0;
    }
    a{
        color: #425EB2;
    }
    p{
        font-size: 14px;
        line-height: 1;
    }
    .el-image {
        height: auto;
        cursor: pointer;
        
        &.enlarged {
            transform: scale(1.2);
            transform-origin: center;
            transition: transform 0.3s ease;
        }
        
        &.pc-image {
            width: 667px;
            margin:40px 0 0 40px;
        }
        
        &.app-image {
            width: 159px;
            margin:20px 0 0 0;
        }
    }
    ul{
        padding: 0 0 0 20px;
        line-height: 21px;
        li{
            font-size: 14px;
            line-height: 21px;
            strong{
                line-height: 1;
                display: block;
                padding: 20px 0 10px 0;
                font-weight: 600;
            }
            p{
                line-height: 1.5;
            }
        }
        
        &.no{
            list-style-type: decimal;
            li{
                list-style: decimal;
            }
        }
        
        &.circle{
            list-style-type: disc;
            li{
                list-style: disc;
            }
        }
    }
}
</style>